import { render, staticRenderFns } from "./ScreeningsUpdateCategory.vue?vue&type=template&id=2f0d25a6&scoped=true&"
import script from "./ScreeningsUpdateCategory.vue?vue&type=script&lang=js&"
export * from "./ScreeningsUpdateCategory.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsUpdateCategory.vue?vue&type=style&index=0&id=2f0d25a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0d25a6",
  null
  
)

export default component.exports